module.exports = __webpack_public_path__ + "img/grammar.ccd1818c.jpeg";